<!-- ✅ Top Header Bar -->
<div class="top-header" *ngIf="!inLoginPage">
  <div style="display: flex; padding: 15px 0px 4px 10px;">
    <div style="width: 33.33%;">
      <div class="toggler-line-button-style" *ngIf="signedIn">
        <mat-slide-toggle (change)="onChange($event)"
          [checked]="persistenceService.get('active_rider_status') == 'true'"
          [disabled]="persistenceService.get('isVerified') != 'true' && !this.riderDetails?.isVerified"
          id="acceptOrder">
        </mat-slide-toggle>
      </div>
    </div>

    <div style="width: 33.33%; display: flex; align-items: center; justify-content: center;">
      <div *ngIf="menuHeader.length > 0">
        <div>{{ menuHeader[0]?.label }}</div>
      </div>
    </div>

    <div style="width: 33.33%; display: flex; justify-content: end;">
      <mat-icon style="font-size: 23px !important; padding-right: 30px;" (click)="helpClick()">
        help_outline
      </mat-icon>
      <mat-icon style="font-size: 26px !important; padding-right: 30px;" (click)="notificationClicked()">
        notifications_none
      </mat-icon>
    </div>
  </div>
</div>

<!-- ✅ Main Container -->
<div id="sub_container">
  <app-loader></app-loader>
  <router-outlet></router-outlet>
</div>

<!-- ✅ Fixed Bottom Toolbar -->
<div class="bottom-toolbar" *ngIf="!inLoginPage">
  <mat-toolbar id="top_toolbar">
    <div id="deviceId" style="height: 0px !important; visibility: hidden;"></div>

    <mat-toolbar-row class="toolbar_row">
      <div style="display: flex; justify-content: space-between; align-items: center; height: 60px;">
        <nav id="navMenuBar" (click)="openNav()"
          style="z-index: 10000; display: flex; justify-content: center; align-items: center; padding: 5px;">

          <div id="myNav" class="overlay">
            <div class="scrollcontent"
              style="display: flex; align-items: center; justify-content: space-between; position: fixed; bottom: 0; height: auto; top: 92%; width: 100%; overflow: hidden; padding: 0px 7px;">

              <!-- Menu Items -->
              <ul role="list" *ngFor="let menu of appitemsTravel" style="border-top: #E6E8EA; width: 14.28%;"
                class="w3-ul">
                <li (click)="menuChange(menu)" role="listitem"
                  style="font-size: small; cursor: pointer; display: flex; align-items: center; flex-direction: column; height: 51px; padding-top: 6px;"
                  [class.selected]="selectedMenu === menu">
                  <img async src="../assets/images/{{menu.image}}" alt="../assets/images/appb.svg"
                    class="module-sub_module-sub_sub_module" />
                  <span style="color: black; font-weight: normal; font-size: 10px;">{{menu.label}}</span>
                </li>
              </ul>

              <!-- Profile Button -->
              <div id="profile_btn" (click)="menuChange(menu1)" [class.selected]="selectedMenu === menu1">
                <button class="toolbar_btn" mat-icon-button [matMenuTriggerFor]="menu1" style="padding-right: 5px;">
                  <mat-icon style="color: black; font-size: 28px !important;">account_circle</mat-icon>
                </button>
                <span style="color: black; font-weight: normal; font-size: 10px;">Profile</span>
              </div>

              <!-- Profile Menu -->
              <mat-menu #menu1="matMenu">
                <div>
                  <div class="menuLogoIcon">
                    <mat-icon class="image-holder-icon">account_circle</mat-icon>
                  </div>
                  <h4 class="menuTitleText" (click)="$event.stopPropagation();"> {{name}} </h4>

                  <!-- Ratings -->
                  <div *ngIf="!inSignInOrUp" class="rating-section">
                    <p class="menuSubtitleText">Customer:</p>
                    <div class="rating-container">
                      <ng-template #t let-fill="fill">
                        <span class="star" [class.full]="fill === 100">
                          <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
                        </span>
                      </ng-template>
                      <ngb-rating [readonly]="true" [max]="5" [(rate)]="avgRatingByCustomerValue" [starTemplate]="t"
                        class="menuSubtitleText"></ngb-rating>
                      <p class="menuSubtitleText" style="margin-left: 10px;">({{ avgRatingByCustomerValue | number :
                        '1.2-2'}})</p>
                    </div>
                  </div>

                  <div *ngIf="!inSignInOrUp" class="rating-section">
                    <p class="menuSubtitleText">Location:</p>
                    <div class="rating-container">
                      <ng-template #t let-fill="fill">
                        <span class="star" [class.full]="fill === 100">
                          <span class="half" [style.width.%]="fill">&#9733;</span>&#9733;
                        </span>
                      </ng-template>
                      <ngb-rating [readonly]="true" [max]="5" [(rate)]="avgRatingByLocationValue" [starTemplate]="t"
                        class="menuSubtitleText"></ngb-rating>
                      <p class="menuSubtitleText" style="margin-left: 10px;">({{ avgRatingByLocationValue | number :
                        '1.2-2'}})</p>
                    </div>
                  </div>

                  <button mat-menu-item (click)="$event.stopPropagation();">
                    <mat-icon class="menuItemColor">email</mat-icon>
                    <span class="menuSubtitleText">{{id}}</span>
                  </button>

                  <div *ngIf="!inSignInOrUp">
                    <button type="button" mat-menu-item (click)="profile()">
                      <mat-icon class="menuItemColor">person</mat-icon>
                      <span class="menuSubtitleText">My Details</span>
                    </button>
                  </div>

                  <div>
                    <button type="button" mat-menu-item (click)="logout()">
                      <mat-icon class="menuItemColor" style="color: red;">power_settings_new</mat-icon>
                      <span class="menuSubtitleText">Sign Out</span>
                    </button>
                  </div>
                </div>
              </mat-menu>
            </div>
          </div>
        </nav>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>